//Core
import {useAuth0, User} from "@auth0/auth0-react";
import {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
//Redux
import {store, useAppDispatch} from "@/redux/store";
import {setUserDataAction, setUserField, setUserId} from "@/redux/user/userSlice";
import {fetchGetUser} from "@/redux/user/userActions";
//Hooks
import {usePathname} from "./usePathname";
import useMixpanel from "./useMixPanel";
//Types
import {TUserData} from "@/types/redux/userTypes";
import {TGetUserActionPayload} from "@/types/services/user/response/userDataResponseTypes";

export const useAuth = () => {
    const { user, getAccessTokenSilently} = useAuth0();
    const {isLoginPage, isHomepage} = usePathname();
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {identifyUser ,setMixpanelUser} = useMixpanel();

    const getToken = async () => {
        try {
            await getAccessTokenSilently();
            isLoginPage && navigate("/");
        } catch (err) {
            console.log('getToken', err);
            !isHomepage && !isLoginPage && navigate("/");
        }
        finally {
            setLoading(false);
        }
    };

    const getUserWithLoader = async (user?: User) => {
        if (user) {
            dispatch(setUserField({ isLoadingUser: true }));
            dispatch(setUserId(user.sub as string));
            identifyUser(user.sub as string);
            setMixpanelUser(user.email, user.name)

            const response = await dispatch(fetchGetUser(user));
            const payload = response?.payload as TGetUserActionPayload;
            console.log(payload)
            if (!payload?.userData) {
                const data: TUserData = {
                    name: !!user.name ? (user.name ?? "") : (user.nickname ?? ""),
                    email: user.email ?? "",
                    wallet: null,
                    image: user.picture ?? "",
                };
                store.dispatch(setUserDataAction(data))
            }
            // console.log(data)
            dispatch(setUserField({ isLoadingUser: false }));
        }
    };
    useEffect(() => {
        // console.log(user)
        void getUserWithLoader(user);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return {
        loading,
        user,
        getToken,
    }
};
